module.exports = __webpack_public_path__ + "img/test123.6efafca1.jpg";